<template>
  <div>
    <b-button
      variant="primary"
      @click="addGoodsItem"
      size="sm"
      class="mb-4"
      squared
    >
      Добавить товар
    </b-button>
    <b-table
      id="data_table"
      hover
      show-empty
      responsive
      ref="goods"
      :fields="fields"
      :items="COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM"
      :current-page="currentPage"
      :per-page="perPage"
      class="mt-3"
      empty-text="Нет данных в таблице"
    >
      <template v-slot:cell(Key)="data">
        <p class="mb-0">{{ data.index + 1 }}</p>
      </template>
      <template v-slot:cell(GoodsCode)="data">
        <p class="mb-0">{{ data.item.GoodsCode }}<br v-if="data.item.GoodsCode">{{ data.item.GoodsDescription }}</p>
      </template>
      <template v-slot:cell(GTDID)="data">
        <p class="mb-0">{{ data.item.GTDID }}<br v-if="data.item.GTDID">{{ data.item.Procedure }}</p>
      </template>
      <template v-slot:cell(GrossWeightQuantity)="data">
        <p class="mb-0">
          <span v-if="data.item.GrossWeightQuantity">брутто&nbsp;{{ data.item.GrossWeightQuantity }}<br></span>
          <span v-if="data.item.NetWeightQuantity">нетто&nbsp;{{ data.item.NetWeightQuantity }}<br></span>
          <span v-if="data.item.WeightTare">тара&nbsp;{{ data.item.WeightTare }}<br></span>
          <span v-if="data.item.GrossTareWeightQuantity">гросс&nbsp;{{ data.item.GrossTareWeightQuantity }}<br></span>
          <span v-if="data.item.VolumeQuantity">объем&nbsp;{{ data.item.VolumeQuantity }}<br></span>
        </p>
      </template>
      <template v-slot:cell(SupplementaryGoodsQuantity)="data">
        <p class="mb-0">{{ data.item.SupplementaryGoodsQuantity }}</p>
      </template>
      <template v-slot:cell(COMMISSIONSHIPMENTPlaces)="data">
        <div v-if="(data.item.COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM[0].PlacesQuantity !== null)">
          <div v-for="(item, index) in data.item.COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM" :key="index">
            {{ item.PlacesQuantity }}&nbsp;{{ item.PlacesDescription }}, {{ item.WeightPackage }}
          </div>
        </div>
      </template>
      <template v-slot:cell(COMMISSIONSHIPMENTContainer)="data">
        <div v-for="(item, index) in data.item.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM" :key="index">
          {{ item.ContainerID }}<br>
        </div>
        <span v-if="data.item.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].ContainerID !== null">Итого: {{ data.item.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length }}</span>
      </template>
      <template v-slot:cell(CodeProcedure)="data">
        <div v-for="(item, index) in data.item.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM" :key="index">
          {{ item.SealId }}<br>
        </div>
      </template>
      <template v-slot:cell(WarehouseName)="data">
        <p class="mb-0">{{ data.item.WarehouseName }}</p>
      </template>
      <template v-slot:cell(COMMISSIONSHIPMENTDocument)="data">
        <div v-for="(item, index) in data.item.COMMISSIONSHIPMENTDocument.COMMISSIONSHIPMENTDOCUMENT_ITEM" :key="index">
          {{ item.DocumentNumber }}<br>
        </div>
      </template>
      <template v-slot:cell(COMMISSIONSHIPMENTDanger)="data">
        <div v-for="(item, index) in data.item.COMMISSIONSHIPMENTDanger.COMMISSIONSHIPMENTDANGER_ITEM" :key="index">
          {{ item.UNNO }}<br>
        </div>
      </template>
      <template v-slot:cell(actions)="data">
        <div class="actions-wrapper">
          <div class="btn-wrapper">
            <b-button id="open-documents-btn" @click="deleteGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Удалить">
              <font-awesome-icon icon="fa-solid fa-xmark" />
            </b-button>
            <b-button id="open-documents-btn" @click="editGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Редактировать">
              <font-awesome-icon icon="fa-solid fa-pencil" />
            </b-button>
            <b-button id="open-documents-btn" @click="cloneGoodsItem(data)" variant="outline-secondary" class="actions-with-outline" v-b-tooltip.hover title="Дублировать">
              <font-awesome-icon icon="fa-solid fa-clone" />
            </b-button>
          </div>
        </div>
      </template>
    </b-table>
    <b-row>
      <b-col xl="6" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="GoodsDescription"
          :name="'Общее описание товаров, подлежащих погрузке'"
          :rules="{ required: true, max: 32768 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-1"
            label-for="GoodsDescription"
            label-class="form-label"
            label="Общее описание товаров, подлежащих погрузке"
            :invalid-feedback="validationContext.errors[0]">
            <b-form-textarea
              id="GoodsDescription"
              v-model="GoodsDescription"
              :class="{ 'required-field': !(!!GoodsDescription) }"
              rows="3"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-textarea>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="12" md="12" sm="12" cols="12">
        <div v-if="!canShowTotalInput" style="font-size: 14px;">
          <h4 class="form-title-summary">Итого: </h4>
          <span>Количество: {{ calcGoodsAmount() }}, </span>
          <span>Контейнеры: {{ calcGoodsContainers() }}, </span>
          <span>Грузовые места количество: {{ calcGoodsPlaces() }}, </span>
          <span>Вес брутто: {{ calcGrossWeightQuantity() }}, </span>
          <span>Вес нетто: {{ calcNetWeightQuantity() }}, </span>
          <span>Вес тары: {{ calcWeightTare() }}, </span>
          <span>Вес гросс: {{ calcGrossTareWeightQuantity() }}, </span>
          <span>Объем: {{ calcVolumeQuantity() }}</span>
        </div>
        <div v-else>
          <b-row class="mt-5">
            <b-col>
              <b-form-group
                id="input-group-75"
                label="Общий вес брутто"
                label-for="input-75"
                :label-class="(!!TotalGrossWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              >
                <b-form-input
                  id="input-75"
                  :class="(!!TotalGrossWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                  v-model="TotalGrossWeightQuantity"
                  placeholder="Общий вес брутто"
                  :disabled="notForEdit"
                  @change="updateIdbData"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-76"
                label="Общий вес нетто"
                label-for="input-76"
                :label-class="(!!TotalNetWeightQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              >
                <b-form-input
                  id="input-76"
                  :class="(!!TotalNetWeightQuantity) ? 'form-input filled-field' : 'form-input'"
                  v-model="TotalNetWeightQuantity"
                  placeholder="Общий вес нетто"
                  :disabled="notForEdit"
                  @change="updateIdbData"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-77"
                label="Общий объем"
                label-for="input-77"
                :label-class="(!!TotalVolumeQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              >
                <b-form-input
                  id="input-77"
                  :class="(!!TotalVolumeQuantity) ? 'form-input filled-field' : 'form-input'"
                  v-model="TotalVolumeQuantity"
                  placeholder="Общий объем"
                  :disabled="notForEdit"
                  @change="updateIdbData"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-78"
                label="Общее количество грузовых мест"
                label-for="input-78"
                :label-class="(!!TotalPlacesQuantity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              >
                <b-form-input
                  id="input-78"
                  :class="(!!TotalPlacesQuantity) ? 'form-input filled-field' : 'form-input'"
                  v-model="TotalPlacesQuantity"
                  placeholder="Общее количество грузовых мест"
                  :disabled="notForEdit"
                  @change="updateIdbData"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <add-goods-page ref="addGoods" @addGoods="saveGoods($event)" @editGoods="saveEditedGoods($event)" @saveEmptyPackageInIdb="$emit('updateCommissionShipment')" :addGood="addGood" :notForEdit="notForEdit"></add-goods-page>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AddGoodsPage from './AddGoodsPage.vue'
  import idbapi from '../../../idbapi/idb.js'
  export default {
    name: "GoodsPage",
    props: ['getValidationState', 'commissionShipmentDoc', 'notForEdit'],
    components: {
      AddGoodsPage
    },
    data () {
      return {
        fields: [
          { key: 'Key', label: '№' },
          { key: 'GoodsCode', label: 'ТНВЭД, Описание товара' },
          { key: 'GTDID', label: '№ДТ, Таможенная процедура' },
          { key: 'GrossWeightQuantity', label: 'Вес (кг), Объём (м3)' },
          { key: 'SupplementaryGoodsQuantity', label: 'Количество' },
          { key: 'COMMISSIONSHIPMENTPlaces', label: 'Грузовые места, вес грузового места (кг)' },
          { key: 'COMMISSIONSHIPMENTContainer', label: 'Контейнер' },
          { key: 'CodeProcedure', label: 'Пломбы' },
          { key: 'WarehouseName', label: 'Склад' },
          { key: 'COMMISSIONSHIPMENTDocument', label: 'Документы' },
          { key: 'COMMISSIONSHIPMENTDanger', label: 'Код класса опасности' },
          { key: 'Actions', label: 'Действия', stickyColumn: true }
        ],
        currentPage: 1,
        totalRows: 1,
        perPage: 0,
        pageOptions: [10, 20, 50],
        COMMISSIONSHIPMENTGoods: {
          COMMISSIONSHIPMENTGOODS_ITEM: []
        },
        GoodsDescription: null,
        TotalGrossWeightQuantity: null,
        TotalNetWeightQuantity: null,
        TotalVolumeQuantity: null,
        TotalPlacesQuantity: null,
        addGood: true,
        editedGoodIndex: null
      }
    },
    watch: {
      commissionShipmentDoc (val) {
        if (val) {
          Object.assign(this.COMMISSIONSHIPMENTGoods, val.data.COMMISSIONSHIPMENTGoods)
          this.GoodsDescription = val.data.GoodsDescription
          this.TotalGrossWeightQuantity = val.data.TotalGrossWeightQuantity
          this.TotalNetWeightQuantity = val.data.TotalNetWeightQuantity
          this.TotalVolumeQuantity = val.data.TotalVolumeQuantity
          this.TotalPlacesQuantity = val.data.TotalPlacesQuantity
        }
      },
    },
    mounted () {},
    computed: {
      canShowTotalInput () {
        const hasRights = this.userInfo.rights.user.filter(item => {
          return item === 'show_commissionshipment_total_input'
        })
        return (hasRights.length > 0)
      },
      ...mapState({
        userInfo: state => state.authorization.userInfo,
      })
    },
    methods: {
      async cloneGoodsItem (data) {
        const good = this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM[data.index]
        this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.push(good)
        await this.updateIdbData()
      },
      updateIdbData () {
        this.$emit('updateCommissionShipment')
      },
      calcGoodsAmount () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.SupplementaryGoodsQuantity === null) || (current.SupplementaryGoodsQuantity === '')) ? 0 : parseFloat(current.SupplementaryGoodsQuantity))
        }, 0)
      },
      calcGoodsContainers () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          if ((current.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length === 1) && (current.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM[0].ContainerID === null)) {
            return sum
          } else {
            return sum + current.COMMISSIONSHIPMENTContainer.COMMISSIONSHIPMENTCONTAINER_ITEM.length
          }
        }, 0)
      },
      calcGoodsPlaces () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          let places = current.COMMISSIONSHIPMENTPlaces.COMMISSIONSHIPMENTPLACES_ITEM.reduce((sum1, current1) => {
            return sum1 + (((current1.PlacesQuantity === null) || (current1.PlacesQuantity === '')) ? 0 : parseFloat(current1.PlacesQuantity))
          }, 0)
          return sum + places
        }, 0)
      },
      calcGrossWeightQuantity () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.GrossWeightQuantity === null) || (current.GrossWeightQuantity === '')) ? 0 : parseFloat(current.GrossWeightQuantity))
        }, 0)
      },
      calcNetWeightQuantity () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.NetWeightQuantity === null) || (current.NetWeightQuantity === '')) ? 0 : parseFloat(current.NetWeightQuantity))
        }, 0)
      },
      calcWeightTare () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.WeightTare === null) || (current.WeightTare === '')) ? 0 : parseFloat(current.WeightTare))
        }, 0)
      },
      calcGrossTareWeightQuantity () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.GrossTareWeightQuantity === null) || (current.GrossTareWeightQuantity === '')) ? 0 : parseFloat(current.GrossTareWeightQuantity))
        }, 0)
      },
      calcVolumeQuantity () {
        return this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.reduce((sum, current) => {
          return sum + (((current.VolumeQuantity === null) || (current.VolumeQuantity === '')) ? 0 : parseFloat(current.VolumeQuantity))
        }, 0)
      },
      async saveGoods (data) {
        this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.push(data.COMMISSIONSHIPMENTGOODS_ITEM[0])
        this.$refs.addGoods.resetSidebarData()
        await this.$emit('updateCommissionShipment')
      },
      async saveEditedGoods (data) {
        this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.splice(this.editedGoodIndex, 1, data.COMMISSIONSHIPMENTGOODS_ITEM[0])
        this.editedGoodIndex = null
        this.$refs.addGoods.resetSidebarData()
        await this.$emit('updateCommissionShipment')
      },
      deleteGoodsItem (row) {
        this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM.splice(row.index, 1)
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              idbapi.deleteGoodFromPackageData(row.index)
            } else {
              this.$emit('updateCommissionShipment')
              setTimeout(() => {
                idbapi.deleteGoodFromPackageData(row.index)
              }, 200)
            }
          }
        )
      },
      editGoodsItem (row) {
        this.addGood = false
        this.editedGoodIndex = row.index
        this.$refs.addGoods.mergeEditedGoodsItem(JSON.parse(JSON.stringify(this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM[row.index])))
      },
      addGoodsItem () {
        this.addGood = true
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
      },
      resetFormData () {
        this.COMMISSIONSHIPMENTGoods.COMMISSIONSHIPMENTGOODS_ITEM = []
        this.GoodsDescription = null
        this.TotalGrossWeightQuantity = null
        this.TotalNetWeightQuantity = null
        this.TotalVolumeQuantity = null
        this.TotalPlacesQuantity = null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .actions-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    .btn-wrapper {
      height: 32px;
      display: flex;
    }
    .actions-with-outline {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      position: relative;
      border: 2px solid #CFD8DC;
      &:nth-child(1) {
        margin-right: 0.75rem;
      }
      &:nth-child(2) {
        margin-right: 0.75rem;
      }
      &:hover {
        color: #fff !important;
        cursor: pointer;
      }
      svg {
        width: 16px;
        height: 16px;
        text-align: center;
        margin-right: 8px;
        position: absolute;
        top: calc((100% - 16px) / 2);
        left: calc((100% - 16px) / 2);
      }
    }
  }
  #GoodsDescription {
    border-radius: 0 !important;
  }
  h4.form-title-summary {
    font-weight: 500;
    color: #25282E;
    font-size: 14px;
    line-height: 20px;
    margin-top: 0;
  }
</style>
